import {useState,useEffect,useRef} from "react";
import { useSelector,useDispatch } from "react-redux";
import { toast } from 'react-toastify';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import ReactLoading from 'react-loading';
import './Callback.scss'
import { getData } from "../Services/APIService";
import config from "../Services/config.json";
import { updateCustomer } from './../../ReduxActions/customerAction';

const  Callback= () => {

    const dispatch = useDispatch();

    const [getLoading,setLoading] = useState(true);
    const [getPaymentResult,setPaymentResult] = useState(true);
    const [getPaymentMessage,setPaymentMessage] = useState('');
    const [getOrderId,setOrderId] = useState('');
    const [getRefId,setRefId] = useState('');
    const [getTransactionDate,setTransactionDate] = useState('');
    const [getTransactionTime,setTransactionTime] = useState('');
    const [bankresponse,setBankresponse]=useState(null);
    const [redirect,setRedirect]=useState(0);
    const bankForm = useRef(null);

    useEffect( () => {
        window.scrollTo(0, 0)
        if(customer.PayWay === 2){
            setLoading(false);
        }
        else{
            handleCheckPayment();
        }
   },[]);

   const handleCheckPayment = async () =>{
    
    let search = window.location.search;
    let params = new URLSearchParams(search);
    var orderId=parseInt(params.get('orderId'));
    //var serviceType=parseInt(params.get('serviceType'));

    //################################################################################################################################## Read Order id Info

    const info={
        token: config.APIKey,
        OrderId:orderId
     };
     try{
        const {data}=await getData('store/CheckOrderId',info);

        if (data.Result !== 4 && data.Message!== null) {
            //toast.error(data.Message,{position:'bottom-left',closeButton:true,closeOnClick:true});
            console.log("StoreError: ",data.Message);
            
            setPaymentMessage(data.Message);
            setOrderId(data.OrderId);
            setRefId(data.RefId);
            setTransactionDate(data.TransactionDate);
            setTransactionTime(data.TransactionTime);
            setPaymentResult(false);
            dispatch(updateCustomer({UserName:data.UserName,Password:data.Password,CustomerCode:data.CustomerCode,FactorCode:data.FactorCode,PayWay:1,serviceType:data.ServiceType,BankName:data.BankName,BankLogo:data.BankLogo,Bank:data.BankCode}));
        }
        else if (data.Result !== 4) {
            //toast.error("خطایی رخ داده است",{position:'bottom-left',closeButton:true,closeOnClick:true});
            console.log("StoreError: ","خطایی رخ داده است");
            setPaymentMessage("خطایی رخ داده است");
        }
        else{
            setOrderId(data.OrderId);
            setRefId(data.RefId);
            setTransactionDate(data.TransactionDate);
            setTransactionTime(data.TransactionTime);
            setPaymentResult(true);
            dispatch(updateCustomer({UserName:data.UserName,Password:data.Password,CustomerCode:data.CustomerCode,FactorCode:data.FactorCode,PayWay:1,serviceType:data.ServiceType,BankName:data.BankName,BankLogo:data.BankLogo,Bank:data.BankCode}));
        }
    }
    catch(ex){
        //toast.error("مشکلی پیش آمده.", {position: "bottom-left",closeOnClick: true});
        console.log("StoreError: ",ex.Message);
    }
    setLoading(false);
   }

    const handleOnCopy = () =>{
        toast.error("کپی شد",{position:'bottom-left',closeButton:true,closeOnClick:true});
    }

    const handleSendPayment= async () =>{
        //پرداخت مجدد

        console.log("StoreLog: ","RePaymenting");

        var siteURL = window.location.protocol + '//' + window.location.host+'/callback';
        siteURL = siteURL.replace( /[.]/g,'__1__').replace(/[:]/g,'__2__').replace(/[/]/g,'__4__');
        var callbackURL=config.apiAddress+'/ChargeOnline/CheckTransaction?myurl='+siteURL;

        const info={
            CustomerCode:customer.CustomerCode,
            FactorCode:customer.FactorCode,
            MyLink:(typeof window !== 'undefined') ? window.location.protocol + '//' + window.location.host:"",
            token: config.APIKey,
            PayWay:customer.PayWay,
            Bank:customer.Bank,
            CallBackURL:callbackURL,
            ServiceType:customer.serviceType
         };

        try{
            const {data}=await getData('store/paymentFactor',info);
            console.log("StoreLog: paymentFactor : ",data.link);

            if (data.Result !== 4 && data.Message!== null) {
                toast.error(data.Message,{position:'bottom-left',closeButton:true,closeOnClick:true});
            }
            else if (data.Result !== 4) {
                toast.error("خطایی رخ داده است دوباره تلاش کنید",{position:'bottom-left',closeButton:true,closeOnClick:true}) 
            }
            else if (customer.PayWay === 1){
                if(data.Message === null || data.Message === ''){
                    dispatch(updateCustomer({RequestType:data.requestType,RequestData:data.Data,RequestLink:data.link}));
                    handleRedirecting(data)
                }
                else{
                    toast.error(data.Message,{position:'bottom-left',closeButton:true,closeOnClick:true}) 
                }
            }
        }
        catch(ex){
            console.log("StoreError: ",ex.Message);
        }
    }

    const handleRedirecting = async (response) => {
        if(response.requestType==0){//GET
            window.open(response.link,"_self");
        }
        else if(response.requestType==1){//POST
            setBankresponse(response);
            setRedirect(1);
            await makeDelay(1000);
            setRedirect(2);
        }
        else if (response.requestType == 2) { // Form
            try {
            const html = response.Data.body;
            if (!html) {
                toast.error("خطایی رخ داده است دوباره تلاش کنید",{position:'bottom-left',closeButton:true,closeOnClick:true}) 
                return;
            }

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            const form = doc.forms[0];
            if (!form) {
                toast.error("خطایی رخ داده است دوباره تلاش کنید",{position:'bottom-left',closeButton:true,closeOnClick:true}) 
                return;
            }

            document.body.appendChild(form);
            form.submit();
            } catch (error) {
            console.error("Form handling error:", error);
            toast.error("خطایی رخ داده است دوباره تلاش کنید",{position:'bottom-left',closeButton:true,closeOnClick:true}) 
            }
        }
    }

    const makeDelay=(ms) => new Promise(
        resolve => setTimeout(resolve, ms)
    );

    //const dispatch = useDispatch();
   const customer = useSelector(state => state.customer);

    return ( 
        <div className="callback">
            {bankresponse && bankresponse.requestType==1 && <form id='bankForm' ref={bankForm} method="POST" action={bankresponse.link}>{Object.keys(bankresponse.Data).map(name => (<input type="hidden" name={name} value={(bankresponse).Data[name]} />))}</form>}
            {redirect == 2 && (bankForm.current).submit() }
            {getLoading ? 
            <>
            <label className="reactLoadingLabel">لطفا منتظر بمانید</label>
            <ReactLoading type="bubbles" color={"#ff8035"} height={150} width={120} className="reactLoading" /> 
            </>
            : 
            <div className="callbackContent">
                <div className={`tiklock${customer.PayWay === 1 && !getPaymentResult ? " tiklockFailed" : ""}`}></div>
                <span className={`lblResult${customer.PayWay === 1 && !getPaymentResult ? " colorRed" : ""}`}>{customer.PayWay === 2 ? "فاکتور با موفقیت ثبت شد" : (getPaymentResult ? "پرداخت با موفقیت ثبت شد" : getPaymentMessage) }</span>
                <span className="lblResultDes">سفارش شما در سیستم ثبت شد، همکاران ما در اولین فرصت با شما تماس خواهند گرفت</span>
                {
                customer.PayWay === 2 || (customer.PayWay === 1 && getPaymentResult) ?
                <>
                <div className="userPassBox">
                    <div className="userPass">
                        <div className="divUser">
                            <CopyToClipboard text={customer.UserName} onCopy={handleOnCopy}>
                                <button className={`divCopy fa fa-files-o ${customer.serviceType === 1 ? " colorADSL" : (customer.serviceType === 2 ? " colorLTE" : "colorGaming")}`}></button>
                            </CopyToClipboard>
                            <div className="divUserPass">
                                <label>نام کاربری</label>
                                <input disabled value={customer.UserName}></input>
                            </div>
                            <div className="divIcon fa fa-user"></div>
                        </div>
                        {/* <div className="divPass">
                            <CopyToClipboard text={customer.Password} onCopy={handleOnCopy}>
                                <button className={`divCopy fa fa-files-o ${customer.serviceType === 1 ? " colorADSL" : (customer.serviceType === 2 ? " colorLTE" : "colorGaming")}`}></button>
                            </CopyToClipboard>
                            <div className="divUserPass">
                                <label>رمز عبور</label>
                                <input disabled value={customer.Password}></input>
                            </div>
                            <div className="divIcon fa fa-lock"></div>
                        </div> */}
                    </div>
                    <div className="userPassLogo"></div>
                </div>
                {/* <span className="lblResultDes">سفارش شما در سیستم ثبت شد، همکاران مادر اولین فرصت با شما تماس خواهند گرفت</span> */}
                </>
                :null
                }
                {
                    customer.PayWay ===1 && getOrderId != '' ?
                    <div className="bankResult">
                        <div className="bankResultItem">
                            <img src={customer.BankLogo} width="60" height="60"></img>
                            <span>{customer.BankName}</span>
                        </div>
                        <div className="bankResultItem">
                            <div>
                                <label className="bankResultLabelTitle">شماره سفارش:</label>
                                <label className="bankResultLabel">{getOrderId}</label>
                            </div>
                            <div>
                                <label className="bankResultLabelTitle"> پیگیری:</label>
                                <label className="bankResultLabel">{getRefId}</label>
                            </div>
                        </div>
                        <div className="bankResultItem">
                            <div>
                                <label className="bankResultLabelTitle">تاریخ:</label>
                                <label className="bankResultLabel">{getTransactionDate}</label>
                            </div>
                            <div>
                                <label className="bankResultLabelTitle">زمان:</label>
                                <label className="bankResultLabel">{getTransactionTime}</label>
                            </div>
                        </div>
                    </div>
                    :null
                }
                {
                customer.PayWay === 2 || (customer.PayWay === 1 && getPaymentResult) ?
                // <div className="btnProfileLogin">
                //     <a href={`http://my.mahannet.ir?userName=${customer.UserName}&password=${customer.Password}`} target="_blank">
                //         ورود به پنل کاربری
                //     </a>
                // </div>
                null
                : 
                <div className="btnProfileLogin" onClick={handleSendPayment}>
                    <span>
                        پرداخت مجدد
                    </span>
                </div>
                }
            </div>
            }
        </div>
     );
}

export default Callback;
